import React from "react";
import { FiAward, FiCheckCircle } from "react-icons/fi";
import { trustBlocks } from "./homePreviewData.js";
import ScrollReveal from "./ScrollReveal.jsx";

export default function HomePreviewTrust() {
  return (
    <section id="preview-trust" className="relative overflow-hidden bg-white py-20">
      <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-zoom-emerald/5 blur-3xl" />
      <div className="pointer-events-none absolute -right-16 bottom-0 h-72 w-72 rounded-full bg-zoom-gold/10 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
        <div className="grid gap-10 lg:grid-cols-[0.78fr_1.22fr] lg:items-start">
          <ScrollReveal direction="right">
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-zoom-gold">DecorZoom Trust</p>
            <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-zoom-emeraldDeep sm:text-[44px] sm:leading-tight">
              Clear support for families planning important celebrations.
            </h2>
            <p className="mt-4 text-base font-normal leading-8 text-zoom-charcoal/66">
              From banquet discovery to decoration themes, DecorZoom keeps the planning experience simple, verified, and responsive.
            </p>
          </ScrollReveal>

          <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
            {trustBlocks.map((item, index) => (
              <ScrollReveal
                key={item}
                delay={index * 0.07}
                className="hp-glass group min-h-[160px] rounded-3xl p-6 shadow-hp-sm transition duration-300 hover:-translate-y-1.5 hover:shadow-hp-glow"
              >
                <div className="flex items-center justify-between">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-zoom-emeraldDeep text-zoom-goldSoft transition duration-300 group-hover:scale-110">
                    {index === 0 ? <FiAward aria-hidden="true" /> : <FiCheckCircle aria-hidden="true" />}
                  </span>
                  <span className="text-xs font-semibold uppercase tracking-[0.18em] text-zoom-gold">0{index + 1}</span>
                </div>
                <h3 className="mt-6 text-xl font-semibold leading-tight text-zoom-emeraldDeep">{item}</h3>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
